export const translations = {
  en: {
    heroTitle: "More than a haircut. Highlighting your individuality.",
    heroSubtitle: "Professional haircuts, modern coloring, and personal care. Your perfect look starts here.",
    heroAlt: "Haircut process in a beauty salon",
    advantagesTitle: "Why choose us?",
    adv1Title: "Expert Stylists",
    adv1Desc: "Certified masters skilled in modern haircut and coloring techniques.",
    adv2Title: "Professional Care",
    adv2Desc: "We use top global brands for the health and beauty of your hair.",
    adv3Title: "Comfort & Care",
    adv3Desc: "Comfortable atmosphere, delicious coffee, and total relaxation while we create your style.",
    pricingTitle: "Popular Services",
    price1Title: "Model Haircut & Styling",
    price1Value: "from 800 UAH",
    price2Title: "Complex Hair Coloring",
    price2Value: "from 1500 UAH",
    price3Title: "Total Look (Haircut + Care/Toning)",
    price3Value: "from 2000 UAH",
    contactTitle: "Contacts",
    contactViber: "Write on Viber",
    contactTelegram: "Write on Telegram",
    mapTitle: "How to find us?",
    mapOpen: "Open in Google Maps",
    instagramTitle: "Our Works",
    instagramFollow: "Follow us",
    qrTitle: "Share this page",
    qrDesc: "Scan the QR code to open the site on your phone",
    demoPopupTitle: "Want a site like this?",
    demoPopupDesc: "Leave a request and we will create a modern website for your business.",
    demoPopupButton: "Order a Site",
    bookingTitle: "Online Booking",
    bookingDesc: "Choose a convenient time and master",
    bookingFormName: "Your Name",
    bookingFormPhone: "Phone Number",
    bookingFormService: "Select Service",
    bookingFormService1: "Men's Haircut",
    bookingFormService2: "Beard Trim",
    bookingFormService3: "Complex",
    bookingFormSubmit: "Confirm Booking",
    footerText: "Site made with",
    bookOnlineBtn: "BOOK ONLINE",
    themeSwitcherTitle: "Settings",
    themeGold: "Gold",
    themeEmerald: "Emerald",
    themeSapphire: "Sapphire",
    themePlatinum: "Platinum",
    themePurple: "Purple",
    modeDark: "Dark",
    modeLight: "Light",
    langEn: "English",
    langUk: "Українська",
    langRu: "Русский"
  },
  uk: {
    heroTitle: "Більше ніж зачіска. Підкреслюємо твою індивідуальність.",
    heroSubtitle: "Професійні стрижки, сучасне фарбування та персональний догляд. Твій ідеальний образ починається тут.",
    heroAlt: "Процес стрижки у салоні краси",
    advantagesTitle: "Чому обирають нас?",
    adv1Title: "Експертні стилісти",
    adv1Desc: "Сертифіковані майстри, які володіють сучасними техніками стрижок та колористики.",
    adv2Title: "Професійний догляд",
    adv2Desc: "Використовуємо топові світові бренди для здоров'я та краси вашого волосся.",
    adv3Title: "Затишок та турбота",
    adv3Desc: "Комфортна атмосфера, смачна кава та повний релакс, поки ми створюємо ваш стиль.",
    pricingTitle: "Популярні послуги",
    price1Title: "Модельна стрижка та укладка",
    price1Value: "від 800 грн",
    price2Title: "Складне фарбування волосся",
    price2Value: "від 1500 грн",
    price3Title: "Total Look (Стрижка + Догляд/Тонування)",
    price3Value: "від 2000 грн",
    contactTitle: "Контакти",
    contactViber: "Написати у Viber",
    contactTelegram: "Написати у Telegram",
    mapTitle: "Як нас знайти?",
    mapOpen: "Відкрити в Google Картах",
    instagramTitle: "Наші роботи",
    instagramFollow: "Підписатися",
    qrTitle: "Поділитися сторінкою",
    qrDesc: "Відскануйте QR-код, щоб відкрити сайт на телефоні",
    demoPopupTitle: "Хочете такий самий сайт?",
    demoPopupDesc: "Залиште заявку, і ми створимо сучасний сайт для вашого бізнесу.",
    demoPopupButton: "Замовити сайт",
    bookingTitle: "Онлайн запис",
    bookingDesc: "Оберіть зручний час та майстра",
    bookingFormName: "Ваше ім'я",
    bookingFormPhone: "Номер телефону",
    bookingFormService: "Оберіть послугу",
    bookingFormService1: "Чоловіча стрижка",
    bookingFormService2: "Стрижка бороди",
    bookingFormService3: "Комплекс",
    bookingFormSubmit: "Підтвердити запис",
    footerText: "Сайт зроблено з",
    bookOnlineBtn: "ЗАПИСАТИСЬ ОНЛАЙН",
    themeSwitcherTitle: "Налаштування",
    themeGold: "Золотий",
    themeEmerald: "Смарагдовий",
    themeSapphire: "Сапфіровий",
    themePlatinum: "Платиновий",
    themePurple: "Фіолетовий",
    modeDark: "Темна",
    modeLight: "Світла",
    langEn: "English",
    langUk: "Українська",
    langRu: "Русский"
  },
  ru: {
    heroTitle: "Больше чем прическа. Подчеркиваем твою индивидуальность.",
    heroSubtitle: "Профессиональные стрижки, современное окрашивание и персональный уход. Твой идеальный образ начинается здесь.",
    heroAlt: "Процесс стрижки в салоне красоты",
    advantagesTitle: "Почему выбирают нас?",
    adv1Title: "Экспертные стилисты",
    adv1Desc: "Сертифицированные мастера, владеющие современными техниками стрижек и колористики.",
    adv2Title: "Профессиональный уход",
    adv2Desc: "Используем топовые мировые бренды для здоровья и красоты ваших волос.",
    adv3Title: "Уют и забота",
    adv3Desc: "Комфортная атмосфера, вкусный кофе и полный релакс, пока мы создаем ваш стиль.",
    pricingTitle: "Популярные услуги",
    price1Title: "Модельная стрижка и укладка",
    price1Value: "от 800 грн",
    price2Title: "Сложное окрашивание волос",
    price2Value: "от 1500 грн",
    price3Title: "Total Look (Стрижка + Уход/Тонирование)",
    price3Value: "от 2000 грн",
    contactTitle: "Контакты",
    contactViber: "Написать в Viber",
    contactTelegram: "Написать в Telegram",
    mapTitle: "Как нас найти?",
    mapOpen: "Открыть в Google Картах",
    instagramTitle: "Наши работы",
    instagramFollow: "Подписаться",
    qrTitle: "Поделиться страницей",
    qrDesc: "Отсканируйте QR-код, чтобы открыть сайт на телефоне",
    demoPopupTitle: "Хотите такой же сайт?",
    demoPopupDesc: "Оставьте заявку, и мы создадим современный сайт для вашего бизнеса.",
    demoPopupButton: "Заказать сайт",
    bookingTitle: "Онлайн запись",
    bookingDesc: "Выберите удобное время и мастера",
    bookingFormName: "Ваше имя",
    bookingFormPhone: "Номер телефона",
    bookingFormService: "Выберите услугу",
    bookingFormService1: "Мужская стрижка",
    bookingFormService2: "Стрижка бороды",
    bookingFormService3: "Комплекс",
    bookingFormSubmit: "Подтвердить запись",
    footerText: "Сайт сделан с",
    bookOnlineBtn: "ЗАПИСАТЬСЯ ОНЛАЙН",
    themeSwitcherTitle: "Настройки",
    themeGold: "Золотой",
    themeEmerald: "Изумрудный",
    themeSapphire: "Сапфировый",
    themePlatinum: "Платиновый",
    themePurple: "Фиолетовый",
    modeDark: "Темная",
    modeLight: "Светлая",
    langEn: "English",
    langUk: "Українська",
    langRu: "Русский"
  }
}

export type Language = 'en' | 'uk' | 'ru';
